import { get, writable } from 'svelte/store'

import { browser } from '$app/environment'
import { messages } from '$lib/messages'
import { apiFetchJson, apiPostJson } from '$lib/proxy/apiProxy'

import { account } from './account/account'
import { getCountry } from './countries'

export type BoSetting = {
	name: string
	value: string
}

export type BoSettings = {
	admin: boolean
	settings: BoSetting[]
}

export type LogoSettings = {
	max_size: {
		unit: string
		value: number
	}
}

export const storeBoSettings = writable(makeBoSettings())

let promiseFetch: Promise<any>
let state: 'pending' | 'reading' | 'ready' = 'pending'

export const InitBoSettings = async (pFetch = fetch) => {
	if (!browser) return
	if (state === 'ready') return
	if (state === 'reading') {
		await promiseFetch
		return
	}

	promiseFetch = fetchBoSettings(pFetch)
	await promiseFetch
	return
}

async function fetchBoSettings(pFetch = fetch) {
	state = 'reading'

	const jsonData = await apiFetchJson(pFetch, 'get', '/bo/settings/get')
	if (!jsonData || jsonData.error) {
		state = 'pending'
		return
	}

	// if (browser)
	if (browser) storeBoSettings.set(jsonData)

	state = 'ready'
	return
}

// UP generic ==== Down custom ===================

function makeBoSettings(): BoSettings {
	return { admin: false, settings: [] }
}

export async function boSettingUpsert(setting: BoSetting) {
	console.log('bo_settings:upsert', setting)

	// UPDATE SETTINGS ---------------------------
	// let bo_json: BoSettings
	const jsonData = await apiPostJson('/bo/setting/upsert', setting)
	if (jsonData?.error) {
		messages.error(`Could not update settings ${jsonData.error}`)
	} else {
		storeBoSettings.set(jsonData)
	}
} 

export const getSettingsValue = (k: string) => {
	const result = _getSettingsValue(k)
	return result
}

function _getSettingsValue(k: string) {
	const kv = get(storeBoSettings).settings.find((e) => e.name === k)
	if (kv) return kv.value

	return ''
}

export function getTrialDays(): number {
	const trial_days = parseInt(getSettingsValue('trial_days'))
	return trial_days
}

export const newLogoSettings = (): LogoSettings => {
	return { max_size: { unit: 'MB', value: 4 } }
}

export const getUnitsBytes = () => [
	{ id: 'Bytes', name: 'Bytes', toBytes: (v: number) => v * 1024 ** 0 },
	{ id: 'KB', name: 'Kilobytes (kB)', toBytes: (v: number) => v * 1024 ** 1 },
	{ id: 'MB', name: 'Megabytes (MB)', toBytes: (v: number) => v * 1024 ** 2 },
	{ id: 'GB', name: 'Gigabytes (GB)', toBytes: (v: number) => v * 1024 ** 3 }
]

const getBytes = (unit: string, value: number): number => {
	const u = getUnitsBytes()
	const i = u.findIndex((u) => u.id === unit)

	if (i >= 0) return u[i].toBytes(value)

	return 0
}

export const getMaxBytes = (): number => {
	const s = getLogoSettings()

	return getBytes(s.max_size.unit, s.max_size.value)
}

export const getLogoSettings = (): LogoSettings => {
	try {
		return JSON.parse(getSettingsValue('logo_settings'))
	} catch {
		return newLogoSettings()
	}
}

// ===========================================
// event_logo
export function hasEventLogo() {
	if (!browser) return false

	const jsonStr = getSettingsValue('event_logo')
	const data = JSON.parse(jsonStr)
	if (data.active == 'default') return false


	// evaluate country
	if (data.active == 'christmas'){
		const country_id = get(account).country_id
		const country = getCountry(country_id)
		return country.christmas
	}
	return true
}
export function getEventLogo() {
	if (!browser) return false

	const jsonStr = getSettingsValue('event_logo')
	const data = JSON.parse(jsonStr)
	return data.active
}
export function getEventLogoOptions() {
	if (!browser) return false

	const jsonStr = getSettingsValue('event_logo')
	const data = JSON.parse(jsonStr)
	return data.options
}





